/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const JupyterNotebookEditorEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('JUPYTER_NOTEBOOK_EDITOR_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class JupyterNotebookEditorEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JupyterNotebookEditorEnabledSettingParser.decode(input).map(res => new JupyterNotebookEditorEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return JupyterNotebookEditorEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JupyterNotebookEditorEnabledSettingParser.encode(data);
    }
    static schema() {
        return JupyterNotebookEditorEnabledSettingParser.schema();
    }
}
